// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__PHvjg","grid":"Header_grid__1qxGH","content":"Header_content__2KwBL"};